const Address = ({ 
  data = { numero_appartement: "", adresse_ligne1: "", adresse_ligne2: "", adresse_ligne3: "", code_postal: "", ville: "", pays: "", country: "" }, 
  withApptNumber = false
}) => {
  const { numero_appartement, adresse_ligne1, adresse_ligne2, adresse_ligne3, code_postal, ville } = data

  return (
    <div className="address uppercase">
      {withApptNumber && numero_appartement && <div className="text-nowrap">{numero_appartement}</div>}
      {adresse_ligne1 && <div className="text-nowrap">{adresse_ligne1}</div>}
      {adresse_ligne2 && <div className="text-nowrap">{adresse_ligne2}</div>}
      {adresse_ligne3 && <div className="text-nowrap">{adresse_ligne3}</div>}
      <div className="text-nowrap">
        {code_postal && <span>{code_postal} </span>}
        {ville && <span className="text-nowrap">{ville}</span>}
      </div>
      {/* {pays && <div>{pays}</div>} */}
    </div>
  )
}

export const SingleLineAddress = ({ 
  data = { numero_appartement: "", adresse_ligne1: "", adresse_ligne2: "", adresse_ligne3: "", code_postal: "", ville: "", country: "", pays: "" },
  apptNumberPrefix = true
}) => {
  const { numero_appartement, adresse_ligne1, adresse_ligne2, adresse_ligne3, code_postal, ville } = data
  const apptNumber = numero_appartement ? `${apptNumberPrefix ? "APPT n°" : ""}${numero_appartement}` : ""
  const address = [apptNumber, adresse_ligne1, adresse_ligne2, adresse_ligne3, `${code_postal} ${ville}`].filter(Boolean).join(', ')
  return (
    <div className="address uppercase">
      {address}
    </div>
  )
}

export const SingleLineAddressOnListing = ({ data = { 
  numero_appartement: "",
  adresse_ligne1: "", adresse_ligne2: "", adresse_ligne3: "", 
  code_postal: "", ville: "", country: "", pays: "" 
}, withCodePostal = true, withApptNumber = true }) => {
  const { numero_appartement = "", adresse_ligne1 = "", adresse_ligne2 = "", adresse_ligne3 = "", code_postal = "", ville = "", pays = "" } = data

  // Fonction pour détecter si une ligne contient probablement une adresse principale (numéro + voie)
  const isMainStreetAddress = (line) => {
    if (!line) return false
    
    // Vérifie si la ligne contient un numéro suivi d'un nom de voie
    const streetPattern = /\d+\s+(rue|avenue|av|boulevard|bd|bvd|chemin|route|impasse|place|allée|cours|quai)/i
    return streetPattern.test(line)
  }

  // Séparer les lignes d'adresse en adresse principale et compléments
  const mainAddressLines = []
  const complementAddressLines = []

  // Vérifier chaque ligne et la classer
  const checkAndClassifyLine = (line) => {
    if (!line) return
    if (isMainStreetAddress(line)) {
      mainAddressLines.push(line)
    } else {
      complementAddressLines.push(line)
    }
  }

  checkAndClassifyLine(adresse_ligne1)
  checkAndClassifyLine(adresse_ligne2)
  checkAndClassifyLine(adresse_ligne3)

  // Si aucune ligne n'a été identifiée comme adresse principale,
  // considérer la première ligne non vide comme l'adresse principale
  if (mainAddressLines.length === 0) {
    if (adresse_ligne1) {
      mainAddressLines.push(adresse_ligne1)
      // Retirer de la liste des compléments si elle y était
      const index = complementAddressLines.indexOf(adresse_ligne1)
      if (index !== -1) complementAddressLines.splice(index, 1)
    } else if (adresse_ligne2) {
      mainAddressLines.push(adresse_ligne2)
      // Retirer de la liste des compléments si elle y était
      const index = complementAddressLines.indexOf(adresse_ligne2)
      if (index !== -1) complementAddressLines.splice(index, 1)
    } else if (adresse_ligne3) {
      mainAddressLines.push(adresse_ligne3)
      // Retirer de la liste des compléments si elle y était
      const index = complementAddressLines.indexOf(adresse_ligne3)
      if (index !== -1) complementAddressLines.splice(index, 1)
    }
  }

  return (
    <div className="address text-left uppercase">
      <p>
        { mainAddressLines.length > 0 && <span>{mainAddressLines.join(', ')}</span> }
        { withCodePostal && code_postal && <span>{mainAddressLines.length > 0 ? ' ' : ''}{code_postal}</span> }
        { !withCodePostal && mainAddressLines.length > 0 && <span>,</span> }
        { ville && <span> {ville}</span> }
        { (withApptNumber && numero_appartement && numero_appartement.length > 0) && <span> - {numero_appartement}</span> }
      </p>
      {complementAddressLines.length > 0 && <p>{complementAddressLines.join(' ')}</p>}
    </div>
  )
}

export default Address